import React, {Fragment} from "react";
import clsx from "clsx";

import IconContainer from "../IconContainer";
import SpecialLink from "./SpecialLink";
import * as blocLiensStyles from "../../../styles/admissions/admissions.module.scss";

const ActionElementList = ({title, actions, color}) => {

    return (<>
        <div
            className={clsx(blocLiensStyles.containerTitleActionElement, {
                [blocLiensStyles.darkBlocLiensEntete]: color === "BLACK",
                [blocLiensStyles.redBlocLiensEntete]: color !== "BLACK"
            })}
        >
            <div className={blocLiensStyles.titleActionElement}>
                <h2 className={blocLiensStyles.relatedTitleActionList}>{title}</h2>
            </div>
        </div>
        <div
            className={clsx(blocLiensStyles.rootActionListCorps, {
                [blocLiensStyles.darkActionListCorps]: color === "BLACK",
                [blocLiensStyles.redActionListCorps]: color !== "BLACK"
            })}
        >
            {actions?.map((action, index, arr) => {
                return (<Fragment key={index}>
                    <div
                        className={clsx(blocLiensStyles.actionMan, {[blocLiensStyles.margin]: index < arr.length - 1})}
                    >
                        <SpecialLink
                            title={action.label}
                            link={action.URL}
                            icon={action.icon === "DOWNLOAD" ? <IconContainer
                                icon={"DOWNLOAD"}
                                color="RED"
                                size={25}
                                variant="outlined"
                                svgClassname={clsx(blocLiensStyles.downloadSVGIcon, blocLiensStyles.actionSVGIcon)}
                                style={{padding: "5px"}}
                            /> : <IconContainer
                                icon={action.icon}
                                color="RED"
                                size={25}
                                variant="outlined"
                                svgClassname={blocLiensStyles.actionSVGIcon}
                                style={{padding: "5px"}}
                            />}
                            window={action.new_window}
                            isRelatedContent={true}
                        />
                    </div>
                    {index < arr.length - 1 && (<div
                        className={clsx(blocLiensStyles.separation, blocLiensStyles.margin)}
                    />)}
                </Fragment>);
            })}
        </div>
    </>);
};

export default ActionElementList;
